var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
var BsDatepickerViewComponent = (function () {
    function BsDatepickerViewComponent() {
        this.onNavigate = new EventEmitter();
        this.onSelect = new EventEmitter();
        this.onHover = new EventEmitter();
    }
    BsDatepickerViewComponent.prototype.navigateTo = function (event) {
        this.onNavigate.emit(event);
    };
    BsDatepickerViewComponent.prototype.hoverHandler = function (event) {
        this.onHover.emit(event);
    };
    BsDatepickerViewComponent.prototype.selectHandler = function (event) {
        this.onSelect.emit(event);
    };
    __decorate([
        Input(),
        __metadata("design:type", Array)
    ], BsDatepickerViewComponent.prototype, "months", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], BsDatepickerViewComponent.prototype, "options", void 0);
    __decorate([
        Output(),
        __metadata("design:type", Object)
    ], BsDatepickerViewComponent.prototype, "onNavigate", void 0);
    __decorate([
        Output(),
        __metadata("design:type", Object)
    ], BsDatepickerViewComponent.prototype, "onSelect", void 0);
    __decorate([
        Output(),
        __metadata("design:type", Object)
    ], BsDatepickerViewComponent.prototype, "onHover", void 0);
    BsDatepickerViewComponent = __decorate([
        Component({
            selector: 'bs-datepicker-view',
            changeDetection: ChangeDetectionStrategy.OnPush,
            template: "\n    <div class=\"bs-datepicker bs-timepicker theme-green\">\n      <div class=\"bs-datepicker-head\">\n        <bs-datepicker-navigation-view\n          *ngFor=\"let month of months\"\n          [month]=\"month\"\n          (onNavigate)=\"navigateTo($event)\"></bs-datepicker-navigation-view>\n      </div>\n      <div class=\"bs-datepicker-body\" *ngFor=\"let month of months\">\n        <bs-datepicker-month-view\n          [month]=\"month\"\n          [options]=\"options\"\n          (onHover)=\"hoverHandler($event)\"\n          (onSelect)=\"selectHandler($event)\"\n        ></bs-datepicker-month-view>\n      </div>\n    </div>\n  "
        })
    ], BsDatepickerViewComponent);
    return BsDatepickerViewComponent;
}());
export { BsDatepickerViewComponent };
//# sourceMappingURL=bs-datepicker-view.component.js.map


//////////////////
// WEBPACK FOOTER
// /revet-web/node_modules/ngx-bootstrap/datepicker/themes/bs/bs-datepicker-view.component.js
// module id = ../../../../ngx-bootstrap/datepicker/themes/bs/bs-datepicker-view.component.js
// module chunks = vendor